import * as moment from 'moment';

export const setTimeOnDate = (
  datetime: string | moment.Moment,
  time: string,
  isUtcReturnValue: boolean
) => {
  if (isUtcReturnValue) {
    datetime = moment.utc(datetime);
    const date = datetime.format('MM/DD/YYYY');
    datetime = moment.utc(`${date} ${time}`, 'MM/DD/YYYY HH:mm');
    return datetime;
  } else {
    datetime = moment(datetime);
    const date = datetime.format('MM/DD/YYYY');
    datetime = moment(`${date} ${time}`, 'MM/DD/YYYY HH:mm');
    return datetime;
  }
};

export const setDateFormat = (dateTime: moment.Moment | undefined) => {
  return dateTime ? moment(dateTime).format('MM/DD/YYYY') : '';
};

export const setDateFormatFromString = (dateTime: string | undefined) => {
  return dateTime ? moment(dateTime).format('MM/DD/YYYY') : '';
};

export function isDifferenceLessThanYears(
  dateTime1Utc: string | moment.Moment | undefined | null,
  dateTime2Utc: string | moment.Moment | undefined | null,
  numYears: number
) {
  if (!dateTime1Utc || !dateTime2Utc) {
    return false;
  }

  const d1 = moment.utc(dateTime1Utc);
  const d2 = moment.utc(dateTime2Utc);
  const diff = moment.duration(d1.diff(d2)).asYears();
  return diff <= numYears;
}
